import { format, startOfWeek } from 'date-fns'

export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '-'
  const date = new Date(value)
  if (isNaN(date.getTime())) return '-'
  return format(date, 'dd.MM.yyyy HH:mm')
}

export function toInputDateTime(value: string | null | undefined): string {
  if (!value) return ''
  const date = new Date(value)
  if (isNaN(date.getTime())) return ''
  return format(date, "yyyy-MM-dd'T'HH:mm")
}

export function fromInputDateTime(value: string | null | undefined): string | null {
  if (!value) return null
  const date = new Date(value)
  if (isNaN(date.getTime())) return null
  return date.toISOString()
}

export function getWeekStartKey(value: Date | string): string {
  const date = typeof value === 'string' ? new Date(value) : value
  return format(startOfWeek(date, { weekStartsOn: 1 }), 'yyyy-MM-dd')
}

/** Credit weeks use Vienna civil dates, independent of the customer's time zone. */
export function getCreditWeekStartKey(value: Date | string): string {
  const date = typeof value === 'string' ? new Date(value) : value
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Vienna', year: 'numeric', month: '2-digit', day: '2-digit',
  }).formatToParts(date)
  const part = (name: string) => Number(parts.find((entry) => entry.type === name)?.value)
  const civilDate = new Date(Date.UTC(part('year'), part('month') - 1, part('day')))
  civilDate.setUTCDate(civilDate.getUTCDate() - (civilDate.getUTCDay() + 6) % 7)
  return civilDate.toISOString().slice(0, 10)
}

function getSessionDeadlineUntil(
  startsAt: string | null | undefined,
  hours: number,
): string | null {
  if (!startsAt) return null
  const start = new Date(startsAt)
  if (isNaN(start.getTime())) return null

  return new Date(start.getTime() - Math.max(0, hours) * 60 * 60 * 1000).toISOString()
}

export function getSessionRegistrationUntil(
  startsAt: string | null | undefined,
  hours: number,
): string | null {
  return getSessionDeadlineUntil(startsAt, hours)
}

export function getSessionCancellationUntil(
  startsAt: string | null | undefined,
  hours: number,
): string | null {
  return getSessionDeadlineUntil(startsAt, hours)
}
